import { Button, Card, ContentContainer, HeadingRow, InlineNotification } from '@msaf/core-react'
import { useEffect, useState } from 'react'
import { DeleteAPIClientModel } from '../../components/api-client/delete-modal'
import { NewAPIClientModal } from '../../components/api-client/new-modal'
import SummaryTable from '../../components/wells/summary-table'
import { usePageState } from '../../context/page-context'

export function UserAPIClients() {
  const { setPageState } = usePageState()
  const [showNewClientModal, setIsNewClientModelOpen] = useState(false)
  const [refreshTableData, setRefreshTableData] = useState(false)
  const [fields, setFields] = useState<Array<Record<string, string | number | boolean>> | null>(null)

  // Delete confirmation modal state Id
  const [deletionRow, setDeletionRow] = useState<{ id: string; name: string } | null>(null)

  useEffect(() => {
    setPageState({
      heading: 'API Clients',
    })

    return () => setPageState({})
  }, [setPageState])

  useEffect(() => {
    setRefreshTableData(false)
  }, [fields])

  const closeModals = () => {
    setDeletionRow(null)
    setRefreshTableData(true)
    setIsNewClientModelOpen(false)
  }

  return (
    <ContentContainer>
      {showNewClientModal && <NewAPIClientModal onRequestClose={closeModals} />}
      {deletionRow != null && (
        <DeleteAPIClientModel id={deletionRow.id} name={deletionRow.name} onRequestClose={closeModals} />
      )}
      <HeadingRow headingText='Clients' headingLevel={2}>
        <Button icon='new' iconAlignment='left' label='Add new client' onClick={() => setIsNewClientModelOpen(true)} />
      </HeadingRow>
      <Card isFullWidth>
        <SummaryTable
          forceRefresh={refreshTableData}
          columnHeaders={[
            {
              elementKey: 'id',
              columnHeading: 'Id',
              viewColumn: 'id',
              type: 'hidden',
            },
            {
              elementKey: 'name',
              columnHeading: 'Name',
              viewColumn: 'name',
              sortable: true,
              type: 'text',
            },
            {
              elementKey: 'clientId',
              columnHeading: 'Client ID',
              viewColumn: 'clientId',
              sortable: false,
              type: 'text',
            },
            {
              elementKey: 'actions',
              columnHeading: 'Actions',
              viewColumn: 'actions',
              type: 'actions-no-data',
              actions: [
                {
                  label: 'Delete',
                  type: 'deleteAction',
                  args: [
                    {
                      elementKey: 'id',
                    },
                    {
                      elementKey: 'name',
                    },
                  ],
                },
              ],
            },
          ]}
          fields={fields}
          requestUrl={'/users/api-client'}
          setFields={setFields}
          defaultSortBy={{
            orderColumn: 'id',
          }}
          tableActionHandlers={{
            deleteAction: (id, name) => setDeletionRow({ id, name }),
          }}
          noResultsComponent={
            <InlineNotification messageType='info' isDismissable={false}>
              No clients created
            </InlineNotification>
          }
        />
      </Card>
    </ContentContainer>
  )
}
